module.exports = __webpack_public_path__ + "images/feature/new-feature-files-32668cbb917e86f04c33733300887a0a.jpg";